import { P24TransactionPanelUrl } from '../const'

export function getP24TransactionPanelUrl(token: string) {
  return P24TransactionPanelUrl + token
}
